<template>
  <nav class="sticky top-3 flex h-fit flex-col items-stretch gap-3 rounded-md bg-gray-100 py-4 transition dark:bg-slate-900">
    <slot />
  </nav>
</template>

<script setup lang="ts"></script>
